import "./index.css";
import "./fonts.css";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import React, { Suspense } from "react";
import { render } from "react-dom";
import App from "./App";
import Spinner from "./components/UI/Spinner/Spinner";
import { StoreProvider } from "./store/store";
import FlagProvider from "@unleash/proxy-client-react";
import { configs as unleashConfigs } from "../config/unleash";

console.log(`Preferences Web App v${APP_VERSION}`);

render(
    <FlagProvider config={unleashConfigs[ENV]}>
        <StoreProvider>
            <I18nextProvider i18n={i18n}>
                <Suspense fallback={<Spinner />}>
                    <App />
                </Suspense>
            </I18nextProvider>
        </StoreProvider>
    </FlagProvider>,
    document.getElementById("root")
);
